import { PROVIDER_TOKEN } from '../assets/constants'
import { TradingAccount, TradingAccountStatus } from '../proto/generated/trading-bridge'
import { openConnectAccountDialog } from '../reducer/orders.reducer'
import { AppDispatch } from '../store'
import { providerCapabilities } from './backendProvider'

export const showPracticeOrderLabel = (): boolean => providerCapabilities.practiceTrade

export const isBrokerSessionReady = (
    primaryTradingAccount?: TradingAccount | null
): boolean => {
    if (providerCapabilities.brokerSessionToken) {
        return !!localStorage.getItem(PROVIDER_TOKEN)
    }
    return primaryTradingAccount?.status === TradingAccountStatus.ACTIVE
}

export const shouldShowTradingAccountReconnect = (
    primaryTradingAccount?: TradingAccount | null
): boolean => {
    // No account directory: there is nothing to reconnect to.
    if (!providerCapabilities.tradingAccountDirectory) {
        return false
    }
    return !isBrokerSessionReady(primaryTradingAccount)
}

export const canPlaceBrokerOrders = (
    primaryTradingAccount?: TradingAccount | null,
    tradingAccounts?: TradingAccount[] | null
): boolean => {
    if (providerCapabilities.brokerSessionToken) {
        return !!localStorage.getItem(PROVIDER_TOKEN)
    }
    return !!(
        primaryTradingAccount &&
        tradingAccounts?.length &&
        primaryTradingAccount.status === TradingAccountStatus.ACTIVE
    )
}

export const ensureTradingAccountForOrders = (
    dispatch: AppDispatch,
    primaryTradingAccount?: TradingAccount | null,
    tradingAccounts?: TradingAccount[] | null
): boolean => {
    if (canPlaceBrokerOrders(primaryTradingAccount, tradingAccounts)) {
        return true
    }
    // No account directory: there is no connect / reconnect dialog to offer.
    if (!providerCapabilities.tradingAccountDirectory) {
        return false
    }
    if (!tradingAccounts?.length || !primaryTradingAccount) {
        dispatch(openConnectAccountDialog({ type: 'connect', tradingAccountId: '' }))
    } else {
        dispatch(openConnectAccountDialog({
            type: 'reconnect',
            tradingAccountId: primaryTradingAccount.accountId
        }))
    }
    return false
}

export const resolveOrderTradingAccountId = (
    primaryTradingAccount?: TradingAccount | null
): string => primaryTradingAccount?.accountId ?? ''
